import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {KingBed } from '@mui/icons-material';
import { Box, useTheme, Divider } from '@mui/material';


import { CounterItem } from '@frontend/features/common/components/CounterItem';

import { HotelSearchRoomInputWidgetItem } from './HotelSearchRoomInputWidgetItem';
import { RoomSelection, HandleRoomChangeProps } from './types';

interface HotelSearchRoomInputWidgetProps {
  onRoomsChange: (rooms: RoomSelection[]) => void;
  defaultRooms:  RoomSelection[] | null,
}

export const HotelSearchRoomInputWidget: FC<HotelSearchRoomInputWidgetProps> = ({ onRoomsChange, defaultRooms }) => {
  const [rooms, setRooms] = useState<RoomSelection[]>([{ paxes: []}]);
  const theme = useTheme();
  const { t } = useTranslation();

  const incrementRoomAmount = () => {
    setRooms((prevState) => [...prevState, { paxes: []}]);
  };

  const decrementRoomAmount = () => {
    if (rooms.length > 1) {
      setRooms((prevState) => prevState.slice(0, -1));
    }
  };

  const handleRoomChange = ({ roomIndex, paxes } : HandleRoomChangeProps) => {
   setRooms((prevState) => prevState.map((room, index) => index === roomIndex ? { paxes } : room ));
  };

  useEffect(() => {
    onRoomsChange(rooms);
  }, [rooms])

  useEffect(() => {
    if(defaultRooms) {
      setRooms(defaultRooms);
    }
  }, [defaultRooms])

  return (
    <Box display="flex" flexDirection="column" height="100%" overflow="auto">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={theme.spacing(1)}
      >
        <CounterItem
          icon={<KingBed color="disabled" sx={{ mr: theme.spacing(4)}}/>}
          itemText={t('hotels.roomMenu.roomAmount')}
          amount={rooms.length}
          onAdd={incrementRoomAmount}
          onRemove={decrementRoomAmount}
          helperText={''}
        />
      </Box>

      <Box display="flex" flexDirection="column" height="100%" overflow="auto">
        {rooms.map((room, idx) => ( 
          <React.Fragment key={`${idx}_${room.paxes.map((age) => age).join('_')}`}>
            <Divider/>
            <HotelSearchRoomInputWidgetItem
              room={room}
              onRoomChange={handleRoomChange}
              roomIndex={idx}
            />
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};
